/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';
import tailwindTheme from '../../../../../config/tailwind.config';

const MultipleTabsModal = ({
  title, tabs, handleCloseDialog,
}) => {
  const [activeTab, setActiveTab] = useState(Object.keys(tabs)[0]);
  const mouseDownOnBackdrop = useRef(false);

  const handleBackdropMouseDown = (e) => {
    mouseDownOnBackdrop.current = e.target === e.currentTarget;
  };

  const handleBackdropClick = (e) => {
    if (mouseDownOnBackdrop.current && e.target === e.currentTarget) {
      handleCloseDialog();
    }
    mouseDownOnBackdrop.current = false;
  };

  return (
    <div
      className="fixed inset-0 bg-modal-background flex justify-center items-center z-50"
      onMouseDown={handleBackdropMouseDown}
      onClick={handleBackdropClick}
    >
      <div className="bg-vamos-white w-2/5 rounded-md shadow-lg relative" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center p-4">
          <h2 className="text-2xl font-bold">{title}</h2>
          <button
            type="button"
            className="focus:outline-none hover:bg-vamos-light-gray rounded-full p-1 cursor-pointer"
            onClick={handleCloseDialog}
            aria-label="Close"
          >
            <IoClose size={24} color={tailwindTheme.theme.extend.colors['vamos-gray']} />
          </button>
        </div>
        <div className="pl-4 space-x-4 border-b">
          {Object.keys(tabs).map(tabKey => (
            <button
              key={tabKey}
              className={`flex-1 p-2 text-center text-lg font-medium focus:outline-none ${activeTab === tabKey ? 'border-b-2 border-vamos-black text-vamos-black' : 'text-vamos-gray'
              }`}
              onClick={() => setActiveTab(tabKey)}
              type="button"
            >
              {tabs[tabKey].label}
            </button>
          ))}
        </div>
        <div className="text-center px-7 pt-6 flex flex-col text-lg pb-2">
          {tabs[activeTab].content}
        </div>
      </div>
    </div>
  );
};

MultipleTabsModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  tabs: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
  })).isRequired,
};

export default MultipleTabsModal;
